import { z } from "zod";

const count = z.number().int().nonnegative();

export const dashboardHealth = z.object({
  autopayPausedEnrollments: count,
  autopayFailedItemsLast7Days: count,
  stuckNotifications: count,
  overdueInvoices: count,
  documentsExpiringSoon: count,
  unassignedUpcomingAppointments: count,
});
export type DashboardHealth = z.infer<typeof dashboardHealth>;

export const dashboardStats = z.object({
  totalClients: count,
  totalVendors: count,
  totalSubContractors: count,
  totalProperties: count,
  totalAppointments: count,
  appointmentsThisMonth: count,
  appointmentsThisMonthByStatus: z.record(z.string(), count),
  activeDailyWorks: count,
  totalRevenue: z.number(),
  revenueThisMonth: z.number(),
  revenueLastMonth: z.number(),
});
export type DashboardStats = z.infer<typeof dashboardStats>;
